<form class="form-horizontal">
    <!--<label class="control-label">{{'config.name' | i18n}}</label>-->
    <!--<input class="form-control" x-ng-model="database.name" />-->

    <label class="control-label">{{'config.choose' | i18n}}</label>
    <div class="row">
        <div class="col-sm-3" x-ng-repeat="d in ui.databases| filter: {type:'!internal'}">
            <div class="thumbnail" x-ng-class="ui.active(d)" x-ng-click="ui.select(d)">
                <img alt="" src="" x-ng-src="{{d.iconUrl}}"/>
                <div class="caption">
                    <span class="caption-label">{{'config.database.type.' + d.type | i18n}}</span>
                </div>
            </div>
        </div>
    </div>
</form>
